import { ActionType } from '@/actions';
import { ActionSetDrawRate } from './interfaces';

export const setDrawRate = (
  game: number,
  drawRate: number
): ActionSetDrawRate => {
  return {
    type: ActionType.DRAW_RATE_SET,
    game,
    drawRate,
  };
};
